<div class="izy-toast" [attr.data-type]="data.type">
  <span class="izy-toast__icon" aria-hidden="true">
    <mat-icon>{{ icon }}</mat-icon>
  </span>

  <div class="izy-toast__body">
    @if (data.title) {
      <p class="izy-toast__title">{{ data.title }}</p>
    }
    <p class="izy-toast__message">{{ data.message }}</p>
  </div>

  <div class="izy-toast__actions">
    @if (data.actionLabel) {
      <button mat-button class="izy-toast__action" (click)="onAction()">
        {{ data.actionLabel }}
      </button>
    }
    <button
      mat-icon-button
      class="izy-toast__close"
      aria-label="Chiudi notifica"
      (click)="dismiss()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (data.duration > 0) {
    <span
      class="izy-toast__progress"
      [style.animation-duration.ms]="data.duration"
      aria-hidden="true"
    ></span>
  }
</div>
